import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import { useCampaignStyleConfig } from '../../../../contexts/CampaignStyleConfigContext'
import { getFooterCampaignSeal } from '../../../../Helpers/getCampaignStyleConfig'
import { logEventToDataCollection } from '../../../../data-tagging'
import { getSaleChannel } from '../../../../contexts/AnalyticsContext/utils'
import { prepareData } from '../../utils'
import catexLinks from '../../links/catex.json'
import sodLinks from '../../links/sod.json'
import { isSod } from '../../../../Helpers'
import useRenderFooter from '../../hooks/useRenderFooter'
import { EVENTS, FLOW_TYPES, ORIGINS } from '../../../../data-tagging/constants'

const FooterSection = ({ isMobile }) => {
  const { campaignStyle } = useCampaignStyleConfig()
  const { campaignSeal } = getFooterCampaignSeal(campaignStyle)
  const [data, setData] = useState(prepareData(isSod() ? sodLinks : catexLinks))
  const { renderDesktop, renderMobile } = useRenderFooter(data, setData, campaignSeal)
  const { ref, inView } = useInView({
    threshold: 0.8,
  })

  useEffect(() => {
    logEventToDataCollection({
      eventName: EVENTS.VIEW_PAGE_SECTION,
      flowType: FLOW_TYPES.FOOTER,
      origin: ORIGINS.FOOTER,
      data: {
        sectionName: 'footer_section',
        saleChannel: getSaleChannel(),
      },
    })
  }, [inView])

  return (
    <footer ref={ref} className="footer">
      <div className="container-footer">{isMobile ? renderMobile : renderDesktop}</div>
    </footer>
  )
}

FooterSection.propTypes = {
  isMobile: PropTypes.bool.isRequired,
}

export default FooterSection
